export const ListQueryKey = 'captainAllowances';
export const DetailQueryKey = 'captainAllowance';

export const Urls = {
  selectUrl: '/allowance/list',
  updateUrl: '/allowance/update',
  deleteUrl: '/allowance/delete',
  createUrl: '/allowance/create',
  detailUrl: '/allowance/detail',
};
